import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const AiCheckIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.container, classObject), src: "/assets/images/icons/ai_check.svg" });
};
const styles = StyleSheet.create({
    container: {},
});
